import { createStripeSubscriptionManagementUrl as createStripeSubscriptionManagementUrlShared } from '@griply/services';
import { httpsCallable } from 'firebase/functions';
import { ID } from 'shared/types/id';

import { getFunctions } from './helpers';

export const createStripeSubscriptionManagementUrl = (stripeCustomerId: ID) =>
  createStripeSubscriptionManagementUrlShared({
    stripeCustomerId,
    functions: getFunctions(),
    httpsCallable,
  });
